<template>
<div>
    <div class="card animated fadeIn" v-if="device.config != null && device.status.dhcp_dns.hosts != null">
        <b-row>
            <b-col sm=6>
                <b-card border-variant="light" v-if="device.status.dhcp_dns.hosts != null">
                    <div slot="header">
                        <strong>Ping:</strong>{{relativeTime(device.status.diagnostics.ping.ts)}}
                        <b-button class="btn btn-primary btn-sm float-right" variant="light" v-if="this.timer===true && device.presence" @click="sendCmd(device.id, 'netPing', 6000)">
                            <b-overlay :show="overlays.netPing" rounded spinner-small spinner-variant="primary">
                                <i class="fa fa-refresh"></i>
                            </b-overlay>
                        </b-button>
                    </div>
                    <preText :data="device.status.diagnostics.ping.data" :deviceID="device.id"></preText>
                </b-card>
            </b-col>
            <b-col sm=6>
                <b-card border-variant="light" v-if="device.status.dhcp_dns.hosts != null">
                    <div slot="header">
                        <strong>Traceroute:</strong> {{relativeTime(device.status.diagnostics.traceroute.ts)}}
                        <b-button class="btn btn-primary btn-sm float-right" variant="light" v-if="this.timer===true && device.presence" @click="sendCmd(device.id, 'traceroute', 8000)">
                            <b-overlay :show="overlays.traceroute" rounded spinner-small spinner-variant="primary">
                            <i class="fa fa-refresh"></i>
                            </b-overlay>
                        </b-button>
                    </div>
                    <preText :data="device.status.diagnostics.traceroute.data" :deviceID="device.id"></preText>
                </b-card>
            </b-col>
        </b-row>
        <!--       <b-row>
        <b-col sm=12>
          <b-card border-variant="light" v-if="device.status.dhcp_dns.hosts != null">
            <div slot="header">
              <strong>Wireless Scans:</strong>{{relativeTime(device.diagnostics.wifiScan.ts)}}
              <b-button class="btn btn-primary btn-sm float-right" variant="light" v-if="this.timer===true && device.presence" @click="sendCmd(device.id, 'wifiScans', 8000)">
                <i class="icon-refresh"></i>
              </b-button>
            </div>
            <wirelessscan :scans="device.status.diagnostics.wifiScan.data" :deviceID="device.id"></wirelessscan>
          </b-card>
        </b-col>
      </b-row> -->

        <b-row>
            <b-col sm=12>
                <b-card border-variant="light" v-if="device.status.dhcp_dns.hosts != null">
                    <div slot="header">
                        <strong>Wi-Fi Scans:</strong>{{relativeTime(device.status.diagnostics.wifiScan.ts)}}
                        <b-button class="btn btn-primary btn-sm float-right" variant="light" v-if="this.timer===true && device.presence" @click="sendCmd(device.id, 'wifiScans', 8000)">
                            <b-overlay :show="overlays.wifiScans" rounded spinner-small spinner-variant="primary">
                            <i class="fa fa-refresh"></i>
                            </b-overlay>
                        </b-button>
                    </div>
                    <wirelessscan :scans="device.status.diagnostics.wifiScan.data" :deviceID="device.id"></wirelessscan>
                </b-card>
            </b-col>
        </b-row>

        <b-row>
            <b-col sm=12>
                <b-card border-variant="light" v-if="device.status.dhcp_dns.hosts != null">
                    <div slot="header">
                        <strong>Speedtest:</strong>{{relativeTime(device.status.diagnostics.speedTest.ts)}}
                        <b-button class="btn btn-primary btn-sm float-right" variant="light" v-if="this.timer===true && device.presence" @click="sendCmd(device.id, 'speedTest', 30000)">
                            <b-overlay :show="overlays.speedTest" rounded spinner-small spinner-variant="primary">
                            <i class="fa fa-refresh"></i>
                            </b-overlay>
                        </b-button>
                    </div>
                    <speedtest :results="device.status.diagnostics.speedTest.data.results" :deviceID="device.id"></speedtest>
                </b-card>
            </b-col>
        </b-row>
    </div>
</div>
</template>

<script>
import moment from 'moment'

import WirelessScan from './WirelessScan'
import preText from './preText'
import speedTest from './speedTest'

export default {
    components: {
        'wirelessscan': WirelessScan,
        'preText': preText,
        'speedtest': speedTest,
    },
    props: {
        device: {
            type: Object,
        },
        changed: {
            type: Array,
        }
    },
    data() {
        return {
            overlays:{
            netPing: false,
            traceroute: false,
            wifiScans: false,
            speedTest: false,
            },

            timer: false,
            stReturn: 0,
        }
    },
    created() {
        this.timer = setInterval(this.enableTimer, 1000);
    },
    methods: {
        enableTimer() {
            this.timer = true;
        },
        beforeDestroy() {
            clearInterval(this.timer)
        },
        relativeTime(value) {
            let localTime = moment.unix(value).local();
            // return (value == null) ? '-' : moment(localTime).fromNow()
            if (value > 0)
                return "Updated  " + moment(localTime).fromNow();
        },
        makeToast(variant = null, message = null) {
            this.$bvToast.toast(message, {
                // title: `Config Updated ${variant || 'default'}`,
                title: `Notification:`,
                variant: variant,
                toaster: 'b-toaster-top-center',
                solid: true,
                autoHideDelay: 2000,
            });
            // toast.show();
        },

        sendCmd(id, op, wait) {

            this.overlays[op]  = true;
            let uri = `/api/devices/${this.device.id}/op?op=${op}`;
            axios.get(uri).then((response) => {
                if (response.data.success === true) {
                    let msg = 'Request sent.' + ' Wait ' + wait / 1000 + ' seconds.';
                    this.makeToast('info', msg);
                    this.stReturn = setTimeout(() => { this.$emit('getData_event');
                        this.overlays[op] = false; }, wait);
                } else {
                    this.makeToast('danger', 'Unable to contact device.');
                }
            });
        },
    },
    beforeDestroy() {
        // console.log("Destroyed")
        clearInterval(this.timer);
        clearTimeout(this.stReturn);
    },
};
</script>
